import { Navigate } from 'react-router-dom'
import { useAuth, type UserRole } from '@/hooks/useAuth'

interface RoleGuardProps {
  children: React.ReactNode
  /** Roles allowed to see this content */
  allowedRoles: UserRole[]
  /** Where to redirect if not allowed (default: /agent) */
  fallback?: string
}

/**
 * Protects routes based on user role.
 * - superadmin: full access
 * - admin: full access
 * - agent: only agent workspace
 */
export default function RoleGuard({ children, allowedRoles, fallback = '/agent' }: RoleGuardProps) {
  const { user } = useAuth()
  const role = user?.role || 'agent'

  if (!allowedRoles.includes(role)) {
    return <Navigate to={fallback} replace />
  }

  return <>{children}</>
}
